import type { FaireProductEntity } from "../../entity_types/product";

export const p_kwunffq4rw: FaireProductEntity = {
  token: "p_kwunffq4rw",
  type: "product",
  name: '(PC)SLICE - MIXED STONES 1.5 x 1.25"',
  brandToken: "b_b1k03395mh",
  brandName: "Oceanic Linkways Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/5397388341b33491ab3643e2ba31087dd18a57ee048dd86b075c9810eb6ed48b.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.52,
  description: '(PC)SLICE - MIXED STONES 1.5 x 1.25"',
  tags: [],
  msrpDollars: 6.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:58.146Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
